import Router from "next/router";
import { gqlReq, GqlReqOptions } from "./";
import { Variables } from "graphql-request";

export const gqlReqNext = async <
	TQuery extends Record<string, any>,
	TVariables extends Variables = Variables,
>(
	opts: GqlReqOptions<TVariables>,
) => {
	const accountName = Router.query["account-name"];
	const headers: GqlReqOptions<TVariables>["headers"] = {
		...opts.headers,
	};

	// Only include account slug header if we have a valid value
	if (accountName && typeof accountName === "string") {
		headers["x-mangomap-account-slug"] = accountName;
	}

	const routeMapId = Router.query["map-id"];
	if (routeMapId && typeof routeMapId === "string") {
		const password = sessionStorage.getItem(`map-password:${routeMapId}`);
		if (password) {
			headers["x-mangomap-map-password"] = password;
		}
	}

	return gqlReq<TQuery, TVariables>({
		...opts,
		headers,
	});
};
